interface IIfProps {
    children: any;
    test: boolean;
}

const If = ({ test, children }: IIfProps) => (test ? children : null);

export default If;
